import React, { useState, useEffect } from "react";
import helperNumber from "../../../../../helpers/numbers";
import helperTime from "../../../../../helpers/time";
import PledgeList from "./PledgeList";

export default function AllPledgeCustomer({ userID }) {
  const [pledges, setPledges] = useState([]);

  useEffect(() => {
    getPledges();
  }, [userID]);

  const getPledges = () => {
    const pledges = PledgeList.filter((user) => user.user_id == userID);
    setPledges(pledges);
  };

  const generatePledgeCustomerTag = () => {
    return (
      <div className="pt-3">
        <div className="alert alert-warning">
          <p className="text-justify">
            <i className="fa fa-info pl-2"></i>
            توجه داشته باشید :{" "}
          </p>
          <ul className="pr-3">
            <li>
              <p className="text-justify">
                بیعانه مبلغی است که جهت رزور جایگاه های انتخابی کمپین شما از
                موجودی حساب شما کسر میشود.
              </p>
            </li>
            <li>
              <p className="text-justify">
                %۳۳ مبلغ کمپین بابت رزور جایگاه های انتخابی شما به عنوان بیعانه
                در زمان درج کمپین از موجودی حساب شما کسر میگردد.
              </p>
            </li>
            <li>
              <p className="text-justify">
                مبلغ بیعانه در صورت اتمام زمان کمپین به حساب شما بازگردانده
                خواهد شد.
              </p>
            </li>
            <li>
              <p className="text-justify">
                در صورت کنسل شدن کمپین مبلغ بیعانه به موجودی حساب شما بازگشت
                داده نخواهد شد.
              </p>
            </li>
          </ul>
        </div>

        <div className="table-responsive">
          <table className="table table-hilite tbl-td-white-space  m-0">
            <thead>
              <tr>
                <td>#</td>
                <td>شماره</td>
                <td>مبلغ (تومان)</td>
                <td>نام کمپین</td>
                <td>وضعیت</td>
                <td>تاریخ اخذ</td>
                <td>تاریخ بازگشت</td>
              </tr>
            </thead>
            <tbody>
              {pledges.map((item, key) => {
                return (
                  <tr key={item.id}>
                    <td>{helperNumber.toPersianNum(key + 1)}</td>
                    <td>{helperNumber.toPersianNum(item.id)}</td>
                    <td className="number-finance">
                      {helperNumber.toPersianNum(
                        helperNumber.toFormatFinanceNumber(item.amount)
                      )}
                    </td>
                    <td>{item.campaign_name}</td>
                    <td>
                      <span className="badge badge-warning">{item.status}</span>
                    </td>
                    <td>{helperNumber.toPersianNum(item.created_at)}</td>
                    <td>
                      {item.returned_at &&
                        helperNumber.toPersianNum(item.returned_at)}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  return generatePledgeCustomerTag();
}
